import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { NeoSuspensionELminarDTO, NeoSuspensionServicioDTO } from '../Model/neoSuspensionServicioDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoSuspensionServicio';
@Injectable({
  providedIn: 'root',
})
export class AdministracionFechasYRangosService {
  constructor(private http: HttpClient) {}

  listaDeHorariosPorIdCliente(idCliente): Observable<NeoSuspensionServicioDTO[]> {
    return this.http.get<NeoSuspensionServicioDTO[]>(`${API_URL}/horariosSuspension/${idCliente}`).pipe(catchError(HandleHttpError));
  }

  datosHorarioPorID(idSuspensionServicio): Observable<NeoSuspensionServicioDTO> {
    return this.http.get<NeoSuspensionServicioDTO>(`${API_URL}/${idSuspensionServicio}`).pipe(catchError(HandleHttpError));
  }

  editarDatosHorarios(horarios: NeoSuspensionServicioDTO): Observable<NeoSuspensionServicioDTO> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');
    return this.http.post<NeoSuspensionServicioDTO>(`${API_URL}/actualizar`,horarios, { headers }).pipe(catchError(HandleHttpError));
  }

  guardarDatosHorarios(horarios: NeoSuspensionServicioDTO): Observable<NeoSuspensionServicioDTO> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');
    return this.http.post<NeoSuspensionServicioDTO>(`${API_URL}/crear`,horarios,{ headers }).pipe(catchError(HandleHttpError));
  }

  eliminarHorario(horarios: NeoSuspensionELminarDTO): Observable<NeoSuspensionELminarDTO> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');
    return this.http.post<NeoSuspensionELminarDTO>(`${API_URL}/eliminar`,horarios,{ headers }).pipe(catchError(HandleHttpError));
  }
}
